import { Injectable } from '@angular/core';
import firebase from "firebase/app";
import { CustomerdatabaseService, FILE } from './customerdatabase.service';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/storage';
import { FirebaseConstants } from '../shared/FirebaseConstants';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class VideoService {


  public tutorialVideos: firebase.firestore.CollectionReference;

  constructor() { 
    this.tutorialVideos = firebase.firestore().collection("tutorialVideos");
  }

  getVideos() {
    return this.tutorialVideos.get();
  }

  addVideo(videoData: any) {
    return this.tutorialVideos.add(videoData);
  }

  deleteVideo(videoId: string) {
    return this.tutorialVideos.doc(videoId).delete();
  }

  updateVideo(videoId: string, videoData: any) {
    return this.tutorialVideos.doc(videoId).update(videoData);
  }

  getVideoById(videoId: string) {
    return this.tutorialVideos.doc(videoId).get();
  }

  getVideosByCategory(category: string) {
    return this.tutorialVideos.where("category", "==", category).get();
  }

  searchVideos(searchTerm: string) {
    return this.tutorialVideos.where("title", ">=", searchTerm).get();
  }
  
}
